import {Component, EventEmitter, Inject, OnInit, Optional, Output, ChangeDetectionStrategy} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {AuthService} from "../../../auth/auth.service";
import {Apollo} from "apollo-angular";
import {EquityInstallmentSharepointService} from "./equity-installment-sharepoint.service";
import {Subscription} from "rxjs";
import {MatCheckboxChange} from "@angular/material/checkbox";
import {EquityInstallmentService} from "../../equity-installment.service";
import {DatePipe} from "@angular/common";
import ProjectInstallmentFundingConditionFile from "../../../interfaces/project-installment-funding-condition-file";

@Component({
    selector: 'equity-installment-documents-panel',
    templateUrl: './equity-installment-documents-panel.component.html',
    styleUrls: ['./equity-installment-documents-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EquityInstallmentDocumentsPanelComponent implements OnInit{
  public spFiles:any[] = []
  public spFileSubscription: Subscription;
  public folders:string[] = []
  public selectedFiles:any[] = []
  public site: string;
  public path:string;
  public serviceSub:Subscription;
  public trackError:Subscription;
  public trackRefresh:Subscription;
  public loadingSub: Subscription;
  public filesSub: Subscription;
  public notifyRefresh: boolean = false;
  public isLoading: boolean = true;
  public hasError: boolean = false;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  constructor(@Optional() @Inject(MAT_BOTTOM_SHEET_DATA)  public data:any, private bottomSheetRef: MatBottomSheetRef<EquityInstallmentDocumentsPanelComponent>, public auth: AuthService, public equityService: EquityInstallmentService, public sharepointService: EquityInstallmentSharepointService, public apollo: Apollo, public datePipe: DatePipe) {
  }

  ngOnInit() {
     this.serviceSub = this.equityService.project$.subscribe(async (result) => {
       if(result.sharepoint_folder){
          this.site = result.sharepoint_folder
          await this.sharepointService.initializeSiteData(result.sharepoint_folder)
          // this.filesSub = this.equityService.projectFundingConditions$.subscribe((result) => {
          //    for(let fundKey of Object.keys(result)){
          //      for(let cond of result[fundKey]){
          //        this.equityService.setErroredFiles(cond.projectInstallmentFundingConditionFiles, fundKey, cond.id)
          //      }
          //    }
          // })
       }
     })


     this.spFileSubscription = this.sharepointService.sharepointFiles$.subscribe((result) => {
        this.spFiles = result;
        this._setBreadcrumb(this.spFiles)
     })

    this.loadingSub = this.sharepointService.isLoading$.subscribe((result) => this.isLoading = result)

    this.trackError = this.sharepointService.hasError$.subscribe((result) => this.hasError = result)

    this.trackRefresh = this.sharepointService.triggerRefresh$.subscribe((result) => this.notifyRefresh = result)
  }

  private _setBreadcrumb(files:any[]){
    this.folders = []
    if(files.length > 0){
      let folderParent = files[0].parentReference?.path
      let pathString = folderParent.split("root:/")[1]
      this.path = pathString;
      let paths = pathString.split("/")
      this.folders.push(...paths)
    } else {
      if(this.path){
        let paths = this.path.split("/")
        this.folders.push(...paths)
      }
    }
  }

  public navigateFolder(folder:string){
    this.selectedFiles = []
    let folderUrl = this.path + "/" + folder
    this.sharepointService.navigateToFolder(folderUrl)
  }

  selectFile(event:any, file:any){
    if(event){
      this.selectedFiles.push(file)
      this.sharepointService.onDrawerFileSelection(this.selectedFiles)
    } else {
      this.selectedFiles = this.selectedFiles.filter((sf) => sf.id !== file.id)
      this.sharepointService.onDrawerFileSelection(this.selectedFiles)
    }
  }

  public breadcrumbNavigation(folder:string){
    // if(this.path===folder){
    //   return;
    // }
    let uriSubstrings = this.path.split("/")
    let idx = uriSubstrings.indexOf(folder)
    const joinedUrl = uriSubstrings.slice(0, idx+1).join("/")
    this.sharepointService.navigateToFolder(joinedUrl)
  }

  public selectAll(event:MatCheckboxChange) {
    if(event.checked){
      for(let sp = 0; sp < this.spFiles.length; sp++){
        let fileAlreadySelected = this.selectedFiles.find((sfiles:ProjectInstallmentFundingConditionFile) => sfiles.id === this.spFiles[sp].id)
        if(this.spFiles[sp].hasOwnProperty('file') && !fileAlreadySelected){
          this.selectedFiles.push(this.spFiles[sp])
        }
      }
      this.sharepointService.onDrawerFileSelection(this.selectedFiles)
    } else {
      this.selectedFiles = []
      this.sharepointService.onDrawerFileSelection(this.selectedFiles)
    }
  }

  public isSelected(file:any){
    return this.selectedFiles.find((data:any) => data.id == file.id)
  }

  public openInSharepoint(){
    let webUrl = this.spFiles[0].webUrl
    let splits = webUrl.split("/")
    splits.pop()
    let url = splits.join("/")
    window.open(url, '_blank')
  }

  public getFileDetails(file:any){
    let user = file.lastModifiedBy.user.displayName
    let date = this.datePipe.transform(file.lastModifiedDateTime, 'yyyy-MM-dd')
    return `Last Modified: ${date}\nLast Modified By: ${user}`
  }

  public closePanel(){
    this.onClose.emit()
    if(Object.keys(this.bottomSheetRef).length > 0){
      this.bottomSheetRef.dismiss()
    }
  }

  ngOnDestroy(){
    this.loadingSub.unsubscribe();
    this.serviceSub.unsubscribe();
    this.trackRefresh.unsubscribe();
    this.spFileSubscription.unsubscribe();
    this.trackError.unsubscribe();
  }


}
